export enum EditFormRowTypes {
  TEXT = 'text',
  AVATAR = 'avatar',
  DATE = 'date',
  CHECKBOX = 'checkbox',
  SELECT = 'select',
  ALERT = 'alert'
}
